/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_ExpiresInputs */

const en_carrier_notices_expires = /** @type {(inputs: Carrier_Notices_ExpiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expires`)
};

const es_carrier_notices_expires = /** @type {(inputs: Carrier_Notices_ExpiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vence`)
};

/**
* | output |
* | --- |
* | "Expires" |
*
* @param {Carrier_Notices_ExpiresInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_expires = /** @type {((inputs?: Carrier_Notices_ExpiresInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_ExpiresInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_expires(inputs)
	return es_carrier_notices_expires(inputs)
});